import { render, staticRenderFns } from "./ParticipantBaseForm.vue?vue&type=template&id=689a8478&"
import script from "./ParticipantBaseForm.vue?vue&type=script&lang=ts&"
export * from "./ParticipantBaseForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports